module.exports = "/_next/static/images/2-aab0d4c8621b9e5f94ab3b71c0e03d1b.gif";